<template>
  <small class="text-gray-500">
    {{ t_('recaptcha-disclaimer') }}
    <AtomLink class="text-app-primary-1-red--fire-brick" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">
      {{ t_('recaptcha-privacy-policy') }}
    </AtomLink>
    {{ t_('recaptcha-and') }}
    <AtomLink class="text-app-primary-1-red--fire-brick" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms">
      {{ t_('recaptcha-terms-of-service') }}
    </AtomLink>
    {{ t_('recaptcha-apply') }}
  </small>
</template>

<script setup lang="ts">
const { t_ } = setupTranslationPrefixer('Form')
</script>
